export default "__VITE_ASSET__nz5dZmkM__"